import { Directive, EventEmitter, Injectable, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable, of, Subject, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { tags } from '../../../_shared/constants/customTags.const';
import { CusomerCreatedFromType } from '../../../_shared/enums/customer/cusomerCreatedFromType.enum';
import { EventActions } from '../../../_shared/enums/eventActions.enum';
import { ReservationMode } from '../../../_shared/enums/reservationMode.enum';
import { Event, EventNew, EventReturn, EventUpdate, FcEvent, ReservationRequest, Slot, VisitNew, VisitReturn } from '../../../_shared/model';
import { PreReservation } from '../../../_shared/model/preReservation.model';
import { HelperService, MfToastService, StorageService } from '../../../_shared/services';
import { SimilarCustomersService } from '../../../_shared/services/similar-customers.service';
import { ReservationService, TermsService, VisitService } from '../../pages/home/_services';
import { WaitingQueueService } from '../../pages/home/_services/waiting-queue.service';
import { AppModulesType } from './../../../_shared/enums/appModulesType.enum';
import { ReservationType } from './../../../_shared/enums/schedule/reservationType.enum';
import { Customer } from './../../../_shared/model/customer.model';
import { ServiceGroup } from './../../../_shared/model/serviceGroup.model';
import { CalendarFilterSettings } from './../../../_shared/model/userGuiSettings/calendarFilterSettings.model';
import { ContractorHaloDoctorSettings } from './../../../_shared/model/userGuiSettings/contractorHaloDoctorSettings.model';
import { ActiveModulesService } from './../../../_shared/services/activeModules.service';
import { BaseState } from './../../../_shared/state/base/base.state';
import { CustomerService } from './../../pages/home/_services/customer.service';

//TODO refakturiranje obvezno
@Directive()
@Injectable({
    providedIn: 'root',
})
export class TermFormHelperService {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private reacurringType: any = tags.RECURRING_NEW;
    private onDestroy$ = new Subject<void>();
    private _addTermForm: FormGroup;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() result: EventEmitter<EventReturn> = new EventEmitter();
    @Output() visitResult: EventEmitter<VisitReturn> = new EventEmitter();
    @Output() showLoading: EventEmitter<boolean> = new EventEmitter();
    @Output() closePopup: EventEmitter<boolean> = new EventEmitter();

    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);
    constructor(
        private toastr: MfToastService,
        private helper: HelperService,
        private reservationRest: ReservationService,
        private storage: StorageService,
        private termRest: TermsService,
        private visitRest: VisitService,
        private waitingQueue: WaitingQueueService,
        private customerRest: CustomerService,
        private modalService: NgbModal,
        private am: ActiveModulesService,
        public store: Store,
        private similarCustomersService: SimilarCustomersService,
    ) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    // private prepareData(formModel:any):Slot{

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public findSimilarCustomers(reservationForm: FormGroup, resRequestData: ReservationRequest): Observable<any> {
        const customerNew: Customer = reservationForm.value.customer;
        const event = _.cloneDeep(resRequestData.event);
        event.customer = customerNew;
        return this.similarCustomersService
            .findSimilarCustomers(this.contractorId, event, false)
            .pipe(tap(customer => reservationForm.controls['customer'].setValue(customer)));
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private manageEditTerm(formModel: any, businessHours: any, resRequestData: ReservationRequest): void {
        const slot: Slot = this.prepareSlotData(formModel);

        //urejanje obstojece rezervacije
        if (businessHours && !this.checkIfTermInBusinessHours(slot, businessHours)) {
            this.helper.displayAlert('Rezervacija zunaj delovnika!', 'Rezervirali boste termin zunaj delovnika, nadaljujem?').then(result => {
                if (result.value) {
                    // uredi rezervacijo
                    this.updateReservation(formModel, resRequestData, slot);
                }
            });
            // } else if (resRequestData.event.recurringId) {
        } else if (resRequestData.event.isRecurring) {
            // //ponavljajoče
            const reservationData: EventNew = this.newReservationFromRecurringData(resRequestData, formModel, slot);

            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const alertSettings: any = {
                html: `
                    <div class="mf-recurring-popup m-radio-list">
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio" id="swal-input1" value="selected" name="mf-recurring-option" checked> To rezervacijo
                            <span></span>
                        </label>
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio" id="swal-input2" value="thisAndNext" name="mf-recurring-option"> To in vse prihodnje rezervacije
                            <span></span>
                        </label>
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio"  id="swal-input2" value="all" name="mf-recurring-option"> Vse rezervacije
                            <span></span>
                        </label>
                    </div>
                    `,
                preConfirm: () => {
                    return (document.querySelector('input[name="mf-recurring-option"]:checked') as HTMLInputElement).value;
                },
            };
            this.helper.displayAlert('Urejanje ponavljajoče rezervacije!', 'Kako želite urediti rezervacijo?', alertSettings).then(result => {
                if (result.value) {
                    if (result.value === 'selected') {
                        reservationData.originDate = _.get(resRequestData, 'oldEvent.start')
                            ? moment(resRequestData.oldEvent.start)
                            : resRequestData.event.start;
                        if (resRequestData.reservationMode === ReservationMode.INTERNAL) {
                            const internalData: EventNew = this.newInternalData(formModel, slot);
                            internalData.recurringId = resRequestData.event.recurringId;
                            internalData.recurring = this.reacurringType.obj.SINGLE.sid;
                            this.createReservation(formModel, slot, resRequestData, internalData);
                        } else {
                            reservationData.recurringId = resRequestData.event.recurringId;
                            reservationData.recurring = this.reacurringType.obj.SINGLE.sid;

                            this.createReservation(formModel, slot, resRequestData, reservationData);
                        }
                    } else if (result.value === 'thisAndNext') {
                        reservationData.originDate = _.get(resRequestData, 'oldEvent.start')
                            ? moment(resRequestData.oldEvent.start)
                            : resRequestData.event.start;
                        if (resRequestData.reservationMode === ReservationMode.INTERNAL) {
                            const internalData: EventNew = this.newInternalData(formModel, slot);
                            internalData.recurringId = resRequestData.event.recurringId;
                            internalData.recurring = this.reacurringType.obj.MONFRI.sid;
                            internalData.recurringType = this.reacurringType.obj.MONFRI.sid;
                            this.createReservation(formModel, slot, resRequestData, internalData);
                        } else {
                            reservationData.recurringId = resRequestData.event.recurringId;
                            reservationData.recurring = this.reacurringType.obj.MONFRI.sid;
                            reservationData.recurringType = this.reacurringType.obj.MONFRI.sid;
                            this.createReservation(formModel, slot, resRequestData, reservationData);
                        }
                    } else if (result.value === 'all') {
                        reservationData.originDate = _.get(resRequestData, 'oldEvent.start')
                            ? moment(resRequestData.oldEvent.start)
                            : resRequestData.event.start;
                        this.reservationRest
                            .getReservationRecurring(this.storage.getSelectedContractor().id, resRequestData.event.prereservationId)
                            .subscribe(res => {
                                formModel.start = moment(res.reservationFrom).format('DD.MM.YYYY');
                                this.updateReservation(formModel, resRequestData, this.prepareSlotData(formModel));
                            });
                    }
                }
            });
        } else {
            // uredi rezervacijo
            this.updateReservation(formModel, resRequestData, slot);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private prepareSlotData(formModel: any): Slot {
        let startDate, endDate;
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line prefer-const
        startDate = moment(formModel.start, 'DD.MM.YYYY')
            .hours(moment(formModel.startTime, 'HH:mm').hours())
            .minutes(moment(formModel.startTime, 'HH:mm').minutes());

        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line prefer-const
        endDate = moment(formModel.start, 'DD.MM.YYYY')
            .hours(moment(formModel.endTime, 'HH:mm').hours())
            .minutes(moment(formModel.endTime, 'HH:mm').minutes());

        return new Slot().deserialize({
            start: startDate.toDate(),
            end: endDate.toDate(),
        });
    }

    public deleteTerm(resRequestData: ReservationRequest): void {
        if (_.get(resRequestData, 'event.isRecurring', false)) {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const alertSettings: any = {
                html: `
                    <div class="mf-recurring-popup m-radio-list">
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio" id="swal-input1" value="selected" name="mf-recurring-option" checked> To rezervacijo
                            <span></span>
                        </label>
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio" id="swal-input2" value="thisAndNext" name="mf-recurring-option"> To in vse prihodnje rezervacije
                            <span></span>
                        </label>
                        <label class="m-radio m-radio--state-brand">
                            <input type="radio"  id="swal-input2" value="all" name="mf-recurring-option"> Vse rezervacije
                            <span></span>
                        </label>
                    </div>
                    `,
                preConfirm: () => {
                    return (document.querySelector('input[name="mf-recurring-option"]:checked') as HTMLInputElement).value;
                },
            };

            this.helper.displayAlert('Brisanje ponavljajoče rezervacije', '', alertSettings).then(result => {
                if (result.value) {
                    resRequestData.event.additionalPrereservationId = _.get(resRequestData, 'event.prereservationId', null);
                    if (result.value === 'selected') {
                        const data: PreReservation = new PreReservation().deserialize(resRequestData.event);
                        data.onlySelected = true;
                        data.fromNowOn = _.get(resRequestData, 'event.start', null);
                        this.termRest
                            .cancelReservation(data)
                            .pipe(takeUntil(this.onDestroy$))

                            .subscribe(
                                () => {
                                    this.toastr.success('Termin je bil izbrisan.');
                                    this.result.emit(
                                        new EventReturn().deserialize({
                                            action: EventActions.DELETE,
                                            fcEvent: undefined,
                                        }),
                                    );
                                },
                                () => {
                                    this.toastr.errorAndSend('Napaka pri  brisanju termina.');
                                },
                            );
                    } else if (result.value === 'thisAndNext') {
                        resRequestData.event.fromNowOn = _.get(resRequestData, 'event.start', null);

                        this.termRest
                            .cancelReservation(new PreReservation().deserialize(resRequestData.event))
                            .pipe(takeUntil(this.onDestroy$))

                            .subscribe(
                                () => {
                                    this.toastr.success('Termin je bil izbrisan.');
                                    this.result.emit(
                                        new EventReturn().deserialize({
                                            action: EventActions.DELETE,
                                            fcEvent: undefined,
                                        }),
                                    );
                                },
                                () => {
                                    this.toastr.errorAndSend('Napaka pri  brisanju termina.');
                                },
                            );
                    } else if (result.value === 'all') {
                        this.termRest
                            .cancelReservation(new PreReservation().deserialize(resRequestData.event))
                            .pipe(takeUntil(this.onDestroy$))

                            .subscribe(
                                () => {
                                    this.toastr.success('Vsi ponavljajoči termini so bili izbrisani.');
                                    this.result.emit(
                                        new EventReturn().deserialize({
                                            action: EventActions.DELETE,
                                            fcEvent: undefined,
                                        }),
                                    );
                                    // this.closePopup.next(true);
                                },
                                () => {
                                    this.toastr.errorAndSend('Napaka pri  brisanju ponavljajočih terminov.');
                                },
                            );
                    }
                }
            });
        } else {
            this.helper.displayAlert('Brisanje rezervacije.', 'Izbrišem rezervacijo?').then(result => {
                if (result.value) {
                    this.termRest
                        .cancelReservation(new PreReservation().deserialize(resRequestData.event))
                        .pipe(takeUntil(this.onDestroy$))

                        .subscribe(
                            () => {
                                this.toastr.success('Termin je bil izbrisan!');
                                this.result.emit(
                                    new EventReturn().deserialize({
                                        action: EventActions.DELETE,
                                        fcEvent: undefined,
                                    }),
                                );
                            },
                            () => {
                                this.toastr.errorAndSend('Napaka pri  brisanju termina.');
                            },
                        );
                }
            });
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private setNotifications(resRequestData: ReservationRequest, formModel: any): void {
        //nastavimo obveščanje;
        if (
            resRequestData.reservationMode !== ReservationMode.INTERNAL &&
            _.has(formModel, 'customer.sendMail') &&
            _.has(formModel, 'customer.sendSms')
        ) {
            formModel.customer.sendMail = formModel.emailNotify;
            formModel.customer.sendSms = formModel.smsNotify;
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public manageTerm(resRequestData: ReservationRequest, addTermForm: FormGroup, businessHours: any): void {
        this._addTermForm = addTermForm;
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formModel: any = addTermForm.getRawValue();
        if (moment(formModel.startTime, 'HH:mm') >= moment(formModel.endTime, 'HH:mm')) {
            this.toastr.warning('Konec se ne sme pričeti pred začetkom termina.');
            return;
        }
        this.setNotifications(resRequestData, formModel);

        if (resRequestData.isEditMode && !resRequestData.isOpenReservation) {
            this.manageEditTerm(formModel, businessHours, resRequestData);
        } else {
            const slot: Slot = this.prepareSlotData(formModel);

            //Dodajanje nove rezervacije/obiska
            switch (resRequestData.reservationMode) {
                case ReservationMode.VISIT:
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line no-case-declarations
                    const visitData: VisitNew = this.newVisitData(formModel, slot);
                    this.createVisit(visitData);
                    break;
                case ReservationMode.INTERNAL:
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line no-case-declarations
                    const internalData: EventNew = this.newInternalData(formModel, slot);
                    this.createReservation(formModel, slot, resRequestData, internalData);
                    break;
                case ReservationMode.QUEUE:
                case ReservationMode.RESERVE:
                case ReservationMode.DRAFT:
                default:
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line no-case-declarations
                    const reservationData: EventNew = this.newReservationData(resRequestData, formModel, slot);
                    if (businessHours && businessHours.length > 0 && !this.checkIfTermInBusinessHours(slot, businessHours)) {
                        this.helper
                            .displayAlert('Rezervacija zunaj delovnika.', 'Rezervirali boste termin zunaj delovnika, nadaljujem?')
                            .then(result => {
                                if (result.value) {
                                    // kreiraj rezervacijo
                                    this.createReservation(formModel, slot, resRequestData, reservationData);
                                }
                            });
                    } else {
                        // kreiraj rezervacijo
                        this.createReservation(formModel, slot, resRequestData, reservationData);
                    }
                    break;
            }
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private newInternalData(formModel: any, slot: Slot): EventNew {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            title: formModel.generictitle,
            contractor: {
                id: this.storage.getSelectedContractor().id,
                subcontractors: [
                    {
                        id: formModel.subcontractor.id,
                    },
                ],
            },
            from: moment(slot.start).format(),
            to: moment(slot.end).format(),
            asset: formModel.assets,
            comment: formModel.comment,
            customTagId: _.get(formModel, 'customTag.id', undefined),
        };
        _.set(data, 'recurringType', _.get(formModel, 'recurring.sid', this.reacurringType.obj.SINGLE.sid));

        if (!_.isNil(formModel.recurringUntil)) {
            _.set(data, 'recurringUntil', moment(_.get(formModel, 'recurringUntil', null), 'DD.MM.YYYY').add(1, 'day'));
        }
        return new EventNew().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private newReservationFromRecurringData(resRequestData: ReservationRequest, formModel: any, slot: Slot): EventNew {
        const data = this.newReservationData(resRequestData, formModel, slot);
        return new EventNew().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public fillRequestData(request: ReservationRequest, formModel: any): ReservationRequest {
        if (_.get(formModel, 'customer.name', false)) {
            _.set(request, 'customerForTerm', formModel.customer);
            request.customerForTerm.sendSms = formModel.smsNotify;
            request.customerForTerm.sendMail = formModel.emailNotify;
        }

        if (_.get(formModel, 'subcontractor.id', false)) {
            _.set(request, 'selectedSubcontractor.id', formModel.subcontractor.id);
        }

        if (_.get(formModel, 'services.id', false)) {
            _.set(request, 'selectedService.id', formModel.services.id);
            const endTime: string = moment(request.selectedTime, 'HH:mm').add(formModel.services.length, 'minutes').format('HH:mm');
            _.set(request, 'selectedTimeEnd', endTime);
        }

        if (_.get(formModel, 'assets', false)) {
            _.set(request, 'selectedAsset', formModel.assets);
        }

        if (_.get(formModel, 'customTag.id', false)) {
            _.set(request, 'customTagId', formModel.customTag.id);
        }

        // const slot: Slot = this.prepareSlotData(formModel);
        // _.set(request, 'start', slot.start);
        // _.set(request, 'end', slot.end);

        return request;
    }

    // public createReservatoinObj(resRequestData: ReservationRequest, formModel: any): EventNew {
    //     const slot: Slot = this.prepareSlotData(formModel);
    //     return this.newReservationData(resRequestData, formModel, slot);
    // }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private newReservationData(resRequestData: ReservationRequest, formModel: any, slot: Slot): EventNew {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            contractor: {
                id: this.storage.getSelectedContractor().id,
                subcontractors: [
                    {
                        id: _.get(formModel, 'subcontractor.id', -1),
                    },
                ],
            },
            from: moment(slot.start).format(),
            to: moment(slot.end).format(),
            comment: formModel.comment,
            hdApp: formModel.hdApp,
            customTagId: _.get(formModel, 'customTag.id', undefined),
            telemed: _.get(formModel, 'telemed', undefined),
            phoneCall: _.get(formModel, 'phoneCall', undefined),
        };
        if (_.get(formModel, 'services.type', 'SERVICE') === 'SERVICE') {
            //izbrana storitev
            if (formModel?.services?.id) {
                _.set(data, 'service.id', formModel?.services?.id);
            }
        } else {
            //izbrana skupina storitev
            _.set(
                data,
                'serviceGroup',
                new ServiceGroup().deserialize({
                    id: _.get(formModel, 'services.id'),
                    name: _.get(formModel, 'services.name'),
                }),
            );
        }
        if (_.get(formModel, 'assets', false)) {
            _.set(data, 'asset', formModel.assets);
        }
        if (_.get(formModel, 'customer.name', false)) {
            _.set(data, 'customer', formModel.customer);
        }
        if (_.get(resRequestData, 'event.recurringId', false)) {
            _.set(data, 'recurringId', resRequestData.event.recurringId);
        }
        if (resRequestData.reservationMode === ReservationMode.DRAFT) {
            _.set(data, 'isDraft', true);
        }
        _.set(data, 'recurringType', _.get(formModel, 'recurring.sid', this.reacurringType.obj.SINGLE.sid));

        if (!_.isNil(formModel.recurringUntil)) {
            //dodamo en dan, ker api tako deluje - drugace je en dan premalo
            _.set(data, 'recurringUntil', moment.utc(_.get(formModel, 'recurringUntil', null), 'DD.MM.YYYY').add(1, 'day'));
        }
        if (
            (formModel.customer && !resRequestData.customerForTerm) ||
            _.get(formModel, 'customer.id', -1) !== _.get(resRequestData, 'customerForTerm.id', -1)
        ) {
            data.newCustomer = true;
        }
        if (_.get(formModel, 'payer')) {
            _.set(data, 'invoicePartnerId', formModel.payer.id);
        }
        //RESERVATION TYPE
        data.reservationType = this.getReservationType(data);
        return new EventNew().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getReservationType(data: any): ReservationType {
        if (this.am.isAM(AppModulesType.HELLO_DOCTOR)) {
            //ce je HD aktiven preverimo da storitev, ki jo bookiramo ni hd storitev
            const hdSettings: ContractorHaloDoctorSettings = this.storage.getContractorSettings().haloDoctor;
            if (
                data?.service?.id &&
                data?.hdApp?.type &&
                (data?.service?.id == hdSettings?.selectedService?.id || data?.service?.id == hdSettings?.selectedServicePhoneCall?.id)
            ) {
                return data?.hdApp?.type;
            }
        }
        return ReservationType.EA;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private newVisitData(formModel: any, slot: Slot): VisitNew {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            contractor: {
                id: this.storage.getSelectedContractor().id,
                subcontractors: [
                    {
                        id: _.get(formModel, 'subcontractor.id', -1),
                    },
                ],
            },
            from: moment(slot.start).format(),
            to: moment(slot.end).format(),
            comment: formModel.comment,
            customTagId: _.get(formModel, 'customTag.id', undefined),
            visitTime: moment(slot.start).format(),
        };
        if (_.get(formModel, 'services.id', false)) {
            _.set(data, 'services', [formModel.services]);
        }
        if (_.get(formModel, 'assets', false)) {
            _.set(data, 'asset', formModel.assets);
        }
        if (_.get(formModel, 'customer.name', false)) {
            _.set(data, 'customer', formModel.customer);
        }

        return new VisitNew().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private checkIfTermInBusinessHours(term: any, businessHours: any[]): boolean {
        const filterdBH = businessHours.filter(bh => bh.daysOfWeek[0] === moment(term.start).day());
        for (const bh of filterdBH) {
            const end1 = this.minutesOfDay(moment(term.end, 'HH:mm')),
                end2 = this.minutesOfDay(moment(bh.endTime, 'HH:mm')),
                start1 = this.minutesOfDay(moment(term.start, 'HH:mm')),
                start2 = this.minutesOfDay(moment(bh.startTime, 'HH:mm'));
            if (end1 <= end2 && start1 >= start2) {
                return true;
            }
        }
        return false;
    }

    private minutesOfDay(m): number {
        return m.minutes() + m.hours() * 60;
    }

    // private updateReservation(model: any, oldModel: any, slot: Slot): void {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getUpdateInternalData(formModel: any, slot: Slot): EventUpdate {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            dateFrom: slot.start,
            dateTo: slot.end,
            subcontractorId: _.get(formModel, 'subcontractor.id', -1),
            title: formModel.generictitle,
            assetId: _.get(formModel, 'assets.id', -1),
            comment: formModel.comment,
            customTagId: _.get(formModel, 'customTag.id', 0),
            forceUpdate: false,
        };

        return new EventUpdate().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getUpdateReservationData(formModel: any, slot: Slot, resRequestData: ReservationRequest): EventUpdate {
        let newReacDate;
        if (resRequestData.oldEvent) {
            //ponavljajoč event
            const diff = moment(resRequestData.event.start).day() - moment(resRequestData.oldEvent.start).day();
            newReacDate = moment(slot.start).add(diff, 'day').toDate();
            // add razlika to slot.start
        }
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            assetId: _.get(formModel, 'assets.id', undefined),
            comment: formModel.comment,
            customer: formModel.customer,
            customTagId: _.get(formModel, 'customTag.id', 0),
            dateFrom: newReacDate ? newReacDate : slot.start,
            dateTo: slot.end,
            forceUpdate: false,
            sendEmail: formModel.emailNotify,
            sendSms: formModel.smsNotify,
            serviceId: _.get(formModel, 'services.id', -1),
            subcontractorId: _.get(formModel, 'subcontractor.id', -1),
            title: formModel.generictitle,
            isDraft: resRequestData.event.isDraft,
            telemed: _.get(formModel, 'telemed', undefined),
        };
        _.set(resRequestData, 'event.isDraft', false);
        //izbrana skupina storitev
        if (_.get(formModel, 'services.type') == 'GROUP') {
            data.serviceGroup = new ServiceGroup().deserialize(formModel.services);
        }
        //ce je vnesen customer na novo
        if (
            (formModel.customer && !resRequestData.customerForTerm) ||
            _.get(formModel, 'customer.id', -1) !== _.get(resRequestData, 'customerForTerm.id', -1)
        ) {
            data.newCustomer = true;
        }

        return new EventUpdate().deserialize(data);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private updateReservation(formModel: any, resRequestData: ReservationRequest, slot: Slot): void {
        let updateData: EventUpdate;
        // ce premikamo termin na katerega stranke ni bilo
        if (resRequestData.noShow) {
            //TODO!
            this.reservationRest
                .copyReservation(formModel.event.prereservationId, {
                    from: formModel.event.start,
                    to: formModel.event.end,
                })
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(
                    res => {
                        this.toastr.success('Termin je bil uspešno prenaročen (kopija).');
                        res.isCopy = true;
                        this.result.next(
                            new EventReturn().deserialize({
                                action: EventActions.EDIT,
                                fcEvent: res,
                            }),
                        );
                        this.showLoading.next(false);
                        // this.showLoadingButton = false;
                        // this.activeModal.dismiss(res);
                    },
                    () => {
                        this.toastr.errorAndSend('Napaka pri prenaročanju termina.');
                        this.showLoading.next(false);
                    },
                );
            return;
        }
        switch (resRequestData.reservationMode) {
            case ReservationMode.INTERNAL:
                updateData = this.getUpdateInternalData(formModel, slot);
                break;
            case ReservationMode.RESERVE:
            case ReservationMode.VISIT:
            case ReservationMode.DRAFT:
            default:
                updateData = this.getUpdateReservationData(formModel, slot, resRequestData);
                break;
        }
        this.updateReservationCall(resRequestData, updateData, formModel);
    }

    private updateReservationCall(resRequestData: ReservationRequest, updateData: EventUpdate, formModel: FormGroup, force: boolean = false): void {
        updateData.forceUpdate = force;

        of(null)
            .pipe(
                switchMap(() => {
                    const customerNew: Customer = this._addTermForm.value.customer;
                    if (customerNew?.createdFrom === CusomerCreatedFromType.PATIENT_APP) {
                        return this.findSimilarCustomers(this._addTermForm, resRequestData).pipe(
                            catchError(() => {
                                return throwError('');
                            }),
                        );
                    }
                    return of(null);
                }),
                switchMap(() => this.reservationRest.updateReservation(resRequestData.event.prereservationId, updateData)),
                takeUntil(this.onDestroy$),
            )
            .subscribe(
                () => {
                    if (resRequestData.isCreateReservationFromDraft) {
                        resRequestData.event.comment = updateData.comment;
                        this.reservationRest
                            .getReservation(this.storage.getSelectedContractor().id, resRequestData.event.prereservationId)
                            .pipe(
                                takeUntil(this.onDestroy$),
                                mergeMap(res => {
                                    resRequestData.event.aggregateId = res?.aggregateId || resRequestData.event.aggregateId;
                                    return this.reservationRest
                                        .sendResevation(new PreReservation().deserialize(resRequestData.event))
                                        .pipe(takeUntil(this.onDestroy$));
                                }),
                            )
                            .subscribe(() => {
                                this.result.next(
                                    new EventReturn().deserialize({
                                        action: EventActions.EDIT,
                                        fcEvent: resRequestData,
                                    }),
                                );
                            });
                    } else {
                        this.result.next(
                            new EventReturn().deserialize({
                                action: EventActions.EDIT,
                                fcEvent: resRequestData,
                            }),
                        );
                    }
                },
                error => {
                    if (this.helper.checkStructError(error, 'updateReservation')) {
                        this.showLoading.next(false);
                        this.findSimilarCustomers(this._addTermForm, resRequestData).subscribe();
                        return;
                    }

                    if (this.helper.checkStructError(error, 'SchedulerException-17')) {
                        this.toastr.warning('Termin je bil spremenjen. Prosimo, osvežite stran.');
                        this.showLoading.next(false);
                        return;
                    }

                    if (this.helper.checkStructError(error, 'updateReservation_2')) {
                        this.toastr.warning('Termin ima ustvarjeno obravnavo, prenaročanje ni več mogoče.');
                        this.showLoading.next(false);
                        return;
                    }
                    //noshow
                    if (this.helper.checkStructError(error, '11')) {
                        this.toastr.warning(this.helper.parseMFError(error));
                        this.showLoading.next(false);
                        return;
                    }
                    if (this.helper.checkStructError(error, 'SchedulerException-3')) {
                        //todo preveri če je res ta napaka!
                        this.helper.displayAlert('Sprememba termina.', 'Termin se prekriva, nadaljujem?').then(result => {
                            if (result.value) {
                                this.updateReservationCall(resRequestData, updateData, formModel, true);
                            } else if (result.dismiss === 'cancel') {
                                // this.showLoadingButton = false;
                                this.showLoading.next(false);
                            }
                        });
                    } else if (this.helper.checkStructError(error, 'SchedulerException-0') && updateData.telemed === true) {
                        this.helper
                            .displayAlert('Nov termin!', 'Termina z ePosvetom ni možno kreirati v preteklosti.', {
                                showConfirmButton: false,
                                cancelButtonText: 'Zapri',
                            })
                            // TODO Ignored with eslint-interactive on 2023-11-10
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
                            .then(result => {});
                        // this.toastr.warning('Termina na morete kreirati v preteklost!');
                    } else if (this.helper.checkStructError(error, 'SchedulerException-0')) {
                        this.helper.displayAlert('Nov termin!', 'Termin se bo kreiral v preteklosti, nadaljujem?').then(result => {
                            if (result.value) {
                                this.updateReservationCall(resRequestData, updateData, formModel, true);
                            }
                        });
                        // this.toastr.warning('Termina na morete kreirati v preteklost!');
                    } else {
                        this.toastr.warning('Napaka pri spremembi termina.');
                        // this.showLoadingButton = false;
                        this.showLoading.next(false);
                        return;
                    }
                },
            );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private sendManagePreReservation(inData: EventNew, resRequestData: ReservationRequest): Observable<any> {
        if (_.has(resRequestData, 'event.case.wqid')) {
            return this.waitingQueue.makePrereservationFromWQItem(resRequestData.event.case.wqid, inData);
        } else {
            return this.reservationRest.sendPreResevation(inData);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createReservation(formModel: any, slot: Slot, resRequestData: ReservationRequest, inData: EventNew, forceUpdate: boolean = false): void {
        inData.forceUpdate = forceUpdate;
        this.sendManagePreReservation(inData, resRequestData)
            .pipe(
                tap(
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    () => {},
                    error => {
                        if (this.helper.checkStructError(error, '13')) {
                            this.helper.displayAlert('Zaseden prostor', 'Izbrani prostor je zaseden, nadaljujem?').then(result => {
                                if (result.value) {
                                    this.createReservation(formModel, slot, resRequestData, inData, true);
                                } else if (result.dismiss === 'cancel') {
                                    // this.showLoadingButton = false;
                                }
                            });
                        } else if (this.helper.checkStructError(error, 'SchedulerException-3')) {
                            this.helper.displayAlert('Nov termin.', 'Termin se prekriva, nadaljujem?').then(result => {
                                if (result.value) {
                                    this.createReservation(formModel, slot, resRequestData, inData, true);
                                } else if (result.dismiss === 'cancel') {
                                    // this.showLoadingButton = false;
                                }
                            });
                        } else if (this.helper.checkStructError(error, 'SchedulerException-0') && formModel.telemed === true) {
                            this.helper
                                .displayAlert('Nov termin.', 'Termina z ePosvetom ni možno kreirati v preteklosti.', {
                                    showConfirmButton: false,
                                    cancelButtonText: 'Zapri',
                                })
                                // TODO Ignored with eslint-interactive on 2023-11-10
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
                                .then(result => {});
                            // this.toastr.warning('Termina na morete kreirati v preteklost!');
                        } else if (this.helper.checkStructError(error, 'SchedulerException-0')) {
                            this.helper.displayAlert('Nov termin.', 'Termin se bo kreiral v preteklosti, nadaljujem?').then(result => {
                                if (result.value) {
                                    this.createReservation(formModel, slot, resRequestData, inData, true);
                                }
                            });
                            // this.toastr.warning('Termina na morete kreirati v preteklost!');
                        } else if (this.helper.checkStructError(error, '16')) {
                            this.helper.displayAlert('Rezervacija na praznik', 'Termin bo rezerviran na praznik. Vseeno nadaljujem?').then(result => {
                                if (result.value) {
                                    this.createReservation(formModel, slot, resRequestData, inData, true);
                                } else if (result.dismiss === 'cancel') {
                                    // this.showLoadingButton = false;
                                }
                            });
                        } else {
                            // this.showLoadingButton = false;

                            console.error('napaka pri predrezervaciji');
                            if (typeof error.json === 'function') {
                                console.error(error);
                                this.toastr.errorAndSend('Napaka pri predrezervaciji. [' + _.get(error, 'errors[0].msg') + ']');
                            } else {
                                this.toastr.errorAndSend('Napaka pri predrezervaciji. [' + error + ']');
                            }
                            // this.isSubmited = false;
                        }
                    },
                ),
                mergeMap(
                    res => {
                        if (inData.recurringType !== this.reacurringType.obj.SINGLE.sid) {
                            res.isRecurring = true;
                        } else {
                            res.isRecurring = false;
                        }
                        switch (resRequestData.reservationMode) {
                            case ReservationMode.DRAFT:
                                return this.reservationRest.sendDraftResevation(res);
                            case ReservationMode.QUEUE:
                                res.qId = resRequestData.event.case.wqid;
                                return this.reservationRest.sendResevation(res);

                            default:
                                return this.reservationRest.sendResevation(res);
                        }
                    },
                    preRes => {
                        preRes.comment = formModel.comment;
                        // TODO Ignored with eslint-interactive on 2023-11-10
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const newEvent: any = {
                            reservationFrom: moment(slot.start),
                            reservationTo: moment(slot.end),
                            prereservationId: preRes.prereservationId,
                            aggregateId: preRes.aggregateId,
                            contractor: {
                                subcontractors: [formModel.subcontractor],
                            },
                            title: formModel.generictitle,
                            customer: _.has(formModel, 'customer.name') ? formModel.customer : undefined,
                            comment: formModel.comment,
                            asset: formModel.assets,
                            // selfFunding: formModel.selfFunding,
                            customTagId: formModel.customTag.id,
                            isRecurring: preRes.isRecurring,
                            recurringId: inData.recurringId,
                            telemed: formModel.telemed,
                        };
                        if (_.get(formModel, 'services.type') == 'GROUP') {
                            //izbrana skupina
                            _.set(newEvent, 'serviceGroup', {
                                id: formModel.services.id,
                                name: formModel.services.name,
                            });
                        } else {
                            //izbrana storitev
                            _.set(newEvent, 'service', formModel.services);
                        }
                        if (resRequestData.reservationMode === ReservationMode.QUEUE) {
                            _.set(newEvent, 'case', _.get(resRequestData, 'event.case'));
                        }
                        if (resRequestData.reservationMode === ReservationMode.DRAFT) {
                            newEvent.status = 7;
                        }
                        const ret = new FcEvent().deserialize({ data: new Event().deserialize(newEvent) }, [formModel.subcontractor]);

                        /**
                         * Spremenimo barvo ozadja, ce je izbrana nastavitev za prikaz barve storitve
                         */
                        const guiGilter: CalendarFilterSettings = _.get(this.storage.getGuiUserSettings(), 'calendar.filter');

                        if (guiGilter?.showServicesColor) {
                            ret.backgroundColor = _.get(newEvent, 'service.color', '#ffffff');
                        }
                        this.result.emit(
                            new EventReturn().deserialize({
                                action: EventActions.NEW,
                                fcEvent: ret,
                                isOpenReservation: _.get(resRequestData, 'isOpenReservation', false),
                                prereservation: preRes.prereservationId,
                            }),
                        );
                        this.showLoading.emit(false);
                    },
                ),
                takeUntil(this.onDestroy$),
            )
            .subscribe(
                () => {
                    // this.storage.deleteCustomerForTerm();
                },
                error => {
                    if (
                        !this.helper.checkStructError(error, 'SchedulerException-0') &&
                        !this.helper.checkStructError(error, 'SchedulerException-3') &&
                        !this.helper.checkStructError(error, '13') &&
                        !this.helper.checkStructError(error, '16')
                    ) {
                        //TODO
                        // this.showLoadingButton = false;
                        console.error('napaka pri rezervaciji');
                        this.toastr.errorAndSend('Napaka pri rezervaciji. [' + error + ']');
                    }
                },
            );
    }

    public createVisit(inData: VisitNew): void {
        this.visitRest
            .createVisit(inData)
            .pipe(takeUntil(this.onDestroy$))

            .subscribe(
                res => {
                    // this.activeModal.dismiss(res);
                    this.visitResult.emit(
                        new VisitReturn().deserialize({
                            action: EventActions.NEW,
                            visitNew: { visitId: res },
                        }),
                    );
                    this.showLoading.emit(false);
                },
                error => {
                    this.showLoading.emit(false);

                    // this.showLoadingButton = false;
                    console.error('napaka pri ustavarjanju obravnave');
                    console.error(error);
                    // this.isSubmited = false;
                    this.toastr.errorAndSend('Napaka pri ustavarjanju obravnave.');
                },
            );
    }
}
